import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  HostListener,
  OnChanges,
  ChangeDetectorRef
} from '@angular/core';
import { AmountFilter, Order } from '../order.interface';
import { OrderService } from '@app/shared/services/order.service';
import { DialogStatusService } from '@app/dashboard/services/dialog-status.service';
import { MatDialog } from '@angular/material';

@Component({
  selector: 'app-orders-list',
  templateUrl: './orders-list.component.html',
  styleUrls: ['./orders-list.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class OrdersListComponent implements OnInit, OnChanges {
  @Input() selectedOrder: Order;
  @Input() filteredOrders: Order[];
  @Input() OrderReady = false;
  @Input() services;
  @Input() driversStatus;

  @Output() amountFilters = new EventEmitter<AmountFilter>();
  @Output() currentOrder = new EventEmitter<Order>();
  @Output() editCheckedOrder = new EventEmitter<Order>();
  @Output() holdUnholdOrder = new EventEmitter<boolean>();

  operator_id = null;
  pending = false;
  displayedOrders: Order[] = [];

  LIST_SIZE = 30;

  constructor(
    private orderService: OrderService,
    private cd: ChangeDetectorRef,
    private dialog: MatDialog,
    private dialogStatus: DialogStatusService
  ) {}

  ngOnInit() {
    this.operator_id = localStorage.getItem('user_id');
  }

  ngOnChanges(simpleChanges): void {
    this.changeListSize(0);
  }

  selectOrder(order: Order) {
    this.currentOrder.emit(order);
    this.selectedOrder = order;
  }

  trackById(index, order) {
    return order.id + order.notifications.length;
  }

  @HostListener('window:keyup', ['$event'])
  hotkeyDown($event) {
    if (
      this.dialog.openDialogs.length != 0 ||
      this.dialogStatus.inputFocused ||
      (this.selectedOrder && this.selectedOrder.cab) ||
      this.driversStatus
    ) {
      return;
    }
    if ($event.keyCode === 32) {
      $event.preventDefault();
      if (this.selectedOrder && this.selectedOrder.is_holding) {
        this.orderService
          .getUnholdOrder({
            id: this.selectedOrder.id
          })
          .subscribe(data => {
            this.displayedOrders[
              this.displayedOrders.findIndex(el => el.id == this.selectedOrder.id)
            ].is_holding = false;
            this.displayedOrders[this.displayedOrders.findIndex(el => el.id == this.selectedOrder.id)][
              'hold_type'
            ] = null;
            this.cd.markForCheck();
          });
      } else {
        this.orderService
          .getHoldOrder({
            id: this.selectedOrder.id
          })
          .subscribe(data => {
            this.displayedOrders[
              this.displayedOrders.findIndex(el => el.id == this.selectedOrder.id)
            ].is_holding = true;
            this.displayedOrders[this.displayedOrders.findIndex(el => el.id == this.selectedOrder.id)]['hold_type'] =
              'primary';
            this.cd.markForCheck();
          });
      }
    }
  }

  getService(id) {
    return this.services.find(el => el.id == id) || {};
  }

  changeListSize(diff) {
    if (this.displayedOrders.length < this.LIST_SIZE) {
      diff = this.LIST_SIZE;
    }
    const size = this.displayedOrders.length + diff;
    if (size > this.filteredOrders.length) {
      this.displayedOrders = this.filteredOrders;
    } else {
      this.displayedOrders = this.filteredOrders.slice(0, size);
    }

    const result = [];
    const map = new Map();
    for (const item of this.displayedOrders) {
      if (!map.has(item.id)) {
        map.set(item.id, true);
        result.push(item);
      }
    }
    this.displayedOrders = result;
    // need normal fix  */
  }

  editOrder(order: Order): void {
    this.editCheckedOrder.emit(order);
  }
}



// WEBPACK FOOTER //
// ./src/app/dashboard/orders-list/orders-list.component.ts